/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_RateInputs */

const en_common_auth_gate_action_rate = /** @type {(inputs: Common_Auth_Gate_Action_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rate products`)
};

const zh_common_auth_gate_action_rate = /** @type {(inputs: Common_Auth_Gate_Action_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为产品评分`)
};

/**
* | output |
* | --- |
* | "rate products" |
*
* @param {Common_Auth_Gate_Action_RateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_rate = /** @type {((inputs?: Common_Auth_Gate_Action_RateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_RateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_rate(inputs)
	return zh_common_auth_gate_action_rate(inputs)
});
export { common_auth_gate_action_rate as "common.auth.gate.action.rate" }